export default __webpack_public_path__ + "static/media/view_for_providers.7a96e491.svg";